import { http } from './http'

export function getSpecialTypes() {
  return http.get('/api/special-types')
}

export function getKitchenSpecialTypes() {
  return http.get('/api/kitchen/special-types')
}

export function createKitchenSpecialType(payload) {
  return http.post('/api/kitchen/special-types', payload)
}

export function updateKitchenSpecialType(id, payload) {
  return http.put(`/api/kitchen/special-types/${id}`, payload)
}

export function setKitchenSpecialTypeActive(id, active) {
  return http.put(`/api/kitchen/special-types/${id}/active`, { active })
}

export function setKitchenSpecialTypeForPrint(id, forPrint) {
  return http.put(`/api/kitchen/special-types/${id}/for-print`, { for_print: forPrint })
}
